var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderComp"},[_c('div',{staticClass:"toolbar"},[_c('button-comp',{staticClass:"btn_download tool_item",attrs:{"classBtn":'btn_orange_min',"textBtn":'Скачать чек',"clickBtn":_vm.downloadOrderDoc}})],1),_c('tbl-one-comp',{attrs:{"rows":_vm.orderTbl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }